import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "../Actions/TenantActions";

const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  header: {},
  data: [],
  tenant: {},
  usersStatus: [],
  lastPage: false,
};

const TenantStore = useGlobalHook(React, initialState, actions);

export default TenantStore;
